import Table from './Table'

export default Table



// WEBPACK FOOTER //
// ./src/components/Table/index.js